export default "__VITE_ASSET__CoDNunlU__"